import Brand from "../../Classes/Brand";
import { brandModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    brandToAdd: new Brand()
}

export default function brandModalReducer(state = initialState, action) {
    switch (action.type) {
        case brandModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case brandModalSliceDispatch.setBrandToAdd: {
            return {
                ...state,
                brandToAdd: action.payload
            }
        }
        default:
            return state
    }
}
